import { useState, useContext } from "react";
import "../../../App.css";
import Listdelete from "./ListDelete";
import Add from "./Add";
//import MekhrazContext from "../MekhrazContaxt";

function Exts(props) {
  const { visible, mekhraz, setMekhrazUpdated } = props;
  const [counter, setCounter] = useState(0);
  const increment = () => {
    setCounter(counter + 1);
  };

  if (!visible) return;
  return (
    <>
      <Add
        increment={increment}
        counter={counter}
        mekhraz={mekhraz}
        setMekhrazUpdated={setMekhrazUpdated}
      />
      <Listdelete
        increment={increment}
        counter={counter}
        setCounter={setCounter}
        mekhraz_id={mekhraz.id}
      />
    </>
  );
}

export default Exts;
